






import { Vue, Component, Prop } from 'vue-property-decorator';
import { ICustomStylingClass } from './types/custom.t';
import CustomContainer from '@/components/Globals/CustomContainer.vue'

@Component({ components: { CustomContainer } })
export default class CustomTooltip extends Vue {

  @Prop()
  customsClasses?: ICustomStylingClass[];

  @Prop()
  customStyle?: ICustomStylingClass[];
}

